import __var_0__ from '@stdlib/vendor/debug.js';
import __var_1__ from '@stdlib/utils/define-property';
import __var_2__ from '@stdlib/plot/components/svg/annotations';
import __var_3__ from '@stdlib/plot/components/svg/clip-path';
import __var_4__ from '@stdlib/plot/components/svg/canvas';
import __var_5__ from '@stdlib/plot/components/svg/graph';
import __var_6__ from '@stdlib/plot/components/svg/title';
import __var_7__ from '@stdlib/plot/components/svg/marks';
import __var_8__ from '@stdlib/plot/components/svg/background';
import __var_9__ from '@stdlib/plot/components/svg/defs';
import __var_10__ from '@stdlib/plot/components/svg/axis';
import __var_11__ from '@stdlib/plot/components/svg/path';
import __var_12__ from '@stdlib/plot/components/svg/symbols';
import __var_13__ from '@stdlib/plot/components/svg/rug';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var logger = __var_0__;
var defineProperty = __var_1__;
var Annotations = __var_2__;
var ClipPath = __var_3__;
var Canvas = __var_4__;
var Graph = __var_5__;
var Title = __var_6__;
var Marks = __var_7__;
var Bkgd = __var_8__;
var Defs = __var_9__;
var Axis = __var_10__;
var Path = __var_11__;
var Symbols = __var_12__;
var Rug = __var_13__;


// VARIABLES //

var debug = logger( 'plot:render:svg:init' );


// MAIN //

/**
* Initializes SVG components.
*
* @private
* @param {Object} state - state
*/
function init( state ) {
	var svg = state.$.svg;

	debug( 'Initializing components...' );

	debug( 'Initializing canvas component...' );
	defineProperty( svg, 'canvas', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': new Canvas({
			'autoRender': false
		})
	});

	debug( 'Initializing definitions component...' );
	defineProperty( svg, 'defs', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': new Defs({
			'autoRender': false
		})
	});

	debug( 'Initializing clipping path component...' );
	defineProperty( svg, 'clipPath', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': new ClipPath({
			'autoRender': false,
			'id': state._clipPathId // eslint-disable-line no-underscore-dangle
		})
	});

	debug( 'Initializing graph component...' );
	defineProperty( svg, 'graph', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': new Graph({
			'autoRender': false
		})
	});

	debug( 'Initializing annotations component...' );
	defineProperty( svg, 'annotations', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': new Annotations({
			'autoRender': false
		})
	});

	debug( 'Initializing title component...' );
	defineProperty( svg, 'title', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': new Title({
			'autoRender': false
		})
	});

	debug( 'Initializing background component...' );
	defineProperty( svg, 'bkgd', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': new Bkgd({
			'autoRender': false
		})
	});

	debug( 'Initializing marks component...' );
	defineProperty( svg, 'marks', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': new Marks({
			'autoRender': false,
			'clipPathId': state._clipPathId // eslint-disable-line no-underscore-dangle
		})
	});

	debug( 'Initializing path component...' );
	defineProperty( svg, 'path', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': new Path({
			'autoRender': false
		})
	});

	debug( 'Initializing symbols component...' );
	defineProperty( svg, 'symbols', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': new Symbols({
			'autoRender': false
		})
	});

	debug( 'Initializing x-axis rug component...' );
	defineProperty( svg, 'xRug', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': new Rug({
			'autoRender': false
		})
	});

	debug( 'Initializing y-axis rug component...' );
	defineProperty( svg, 'yRug', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': new Rug({
			'autoRender': false
		})
	});

	debug( 'Initializing x-axis component...' );
	defineProperty( svg, 'xAxis', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': new Axis({
			'autoRender': false
		})
	});

	debug( 'Initializing y-axis component...' );
	defineProperty( svg, 'yAxis', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': new Axis({
			'autoRender': false
		})
	});

	debug( 'All components initialized.' );
}


// EXPORTS //
export default init;
